import { Environment } from "@fruugo/utilities";

export function initKlarnaOnsiteMessaging() {
  const { environment, klarnaSettings, pageType } = window;

  const { paymentMethodAvailable, onSiteMessagingClientId } = klarnaSettings;

  // Exclude the klarna page as we need the page to always load
  if (!paymentMethodAvailable && pageType != "klarna") return;

  const script = document.createElement("script");
  script.src = "https://js.klarna.com/web-sdk/v1/klarna.js";
  script.setAttribute(
    "data-client-id",
    onSiteMessagingClientId ?? "d10edd40-a39d-5316-b9d3-0c42c4a57ead" // Default to en-GB client ID for unsupported countries/languages
  );
  script.setAttribute(
    "data-environment",
    environment === Environment.Production ? "production" : "playground"
  );
  script.async = true;

  const head = document.getElementsByTagName("head")[0];
  head.appendChild(script);

  const element = document.querySelector("klarna-placement");
  element && element.classList.remove("d-none");
}
